import { onMounted, onUnmounted } from "vue";
import Notify from 'quasar/src/plugins/Notify.js';;

const POLL_INTERVAL_MS = 5 * 60 * 1000; // 5 minutos

export async function fetchAppVersion({ useCacheBuster = false } = {}) {
  const versionUrl = useCacheBuster
    ? `/version.json?_=${Date.now()}`
    : "/version.json";

  const response = await fetch(versionUrl, {
    cache: useCacheBuster ? "no-store" : "default",
  });

  if (!response.ok) {
    return null;
  }

  const { version } = await response.json();
  return version || null;
}

function showUpdateNotification() {
  Notify.create({
    message: "Nova versão disponível!",
    caption: "Atualize a página para garantir o funcionamento correto.",
    color: "primary",
    icon: "system_update",
    position: "bottom-right",
    timeout: 0,
    actions: [
      {
        label: "Atualizar agora",
        color: "white",
        handler: () => window.location.reload(),
      },
      {
        label: "Agora não",
        color: "white",
      },
    ],
  });
}

export function useVersionCheck() {
  let intervalId = null;
  let notified = false;
  let currentVersion = null;

  const checkVersion = async () => {
    if (notified) return;
    try {
      const version = await fetchAppVersion({ useCacheBuster: true });

      if (!version) return;

      if (!currentVersion) {
        currentVersion = version;
        return;
      }

      if (version !== currentVersion) {
        notified = true;
        showUpdateNotification();
      }
    } catch {
      // ignora erros de rede silenciosamente
    }
  };

  const onSwUpdated = () => {
    if (!notified) {
      notified = true;
      showUpdateNotification();
    }
  };

  onMounted(() => {
    void checkVersion();
    document.addEventListener("swUpdated", onSwUpdated);
    intervalId = setInterval(checkVersion, POLL_INTERVAL_MS);
  });

  onUnmounted(() => {
    document.removeEventListener("swUpdated", onSwUpdated);
    if (intervalId) clearInterval(intervalId);
  });
}
